/**
 * Portal 的共享 API 客户端装配(契约规定的 boot 顺序见
 * packages/api-contract/src/v1/auth/index.ts):
 *
 *   1. csrf.bootstrap()  —— 由 CsrfClient 惰性执行:首次写请求
 *      (withRefreshRetry → headers → ensureToken)时自动引导;
 *      页面加载后以 readCsrfCookie() 的 cookie 值为种子,免一次往返。
 *   2. auth.me()         —— 唯一的会话状态来源(HttpOnly cookie,前端不读)。
 *   3. auth.captcha()    —— 每个验证码表单挂载时取一次(见 CaptchaField)。
 *
 * 同源部署(nginx 同域反代 /api/v1/*),ApiClient 用默认 baseUrl='' 与
 * credentials='same-origin';Session cookie 完全由后端 Set-Cookie 负责。
 */
import { ApiClient } from '@web-v4/api-client';
import { CsrfClient, readCsrfCookie } from '@web-v4/csrf-client';
import { AuthClient } from '@web-v4/auth-client';

export const apiClient = new ApiClient();

export const csrfClient = new CsrfClient({
  api: apiClient,
  initialToken: readCsrfCookie(),
});

export const authClient = new AuthClient({ api: apiClient, csrf: csrfClient });
